import React, { Component, Fragment } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';

import api from "../../../api";
import apiFunctions from "../../../api/functions.js"
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"
import ParadigmaDatePicker from "../../../components/ParadigmaDatePicker/ParadigmaDatePicker";
import ParadigmaCurrencyInput from "../../../components/ParadigmaCurrencyInput/ParadigmaCurrencyInput";
import { Monedas } from '../../../views/Monedas/Monedas/constants.js'
import { formatCurrency } from '../../../functions/functions';


class Modal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: null,
            caja_id: null,
            cuenta_id: null,
            tipoMovimiento: 0,
            fecha: moment(),
            monto: '0,00',
            observacion: '',
            monedaOperacion: null,
            montos_pagados: [],
            postVariables: ['caja_id', 'cuenta_id', 'tipoMovimiento', 'monto', 'cuota', 'observacion'],
            errors: [],
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func,
        id: PropTypes.func,
        action: PropTypes.oneOf(['CREATE', 'EDIT', 'DETAIL', 'DELETE']).isRequired,
    }


    resetForm() {
        this.setState({
            id: null,
            caja_id: null,
            cuenta_id: null,
            tipoMovimiento: 0,
            fecha: moment(),
            monto: '0,00',
            monedaOperacion: null,
            montos_pagados: [],
            observacion: '',
            errors: [],
        });
    }

    getData() {
        const { postVariables, fecha } = this.state;
        let data = {};
        postVariables.forEach(x => {
            data[x] = this.state[x];
        });
        data.fecha = fecha.format('YYYY-MM-DDThh:mm');

        return data;
    }

    setData(data) {
        const { action } = this.props;
        if((action==='EDIT' || action==='DELETE') && (data.cuota!=null && data.cuota!=undefined)){
            return {
                allowed: false,
                message: 'No se puede '+((action==='EDIT') ? ('editar') : ('eliminar'))+' un movimiento relacionado a una cuota',
            }
        }

        if((action==='EDIT' || action==='DELETE') && (data.venta!=null && data.venta!=undefined)){
            return {
                allowed: false,
                message: 'No se puede '+((action==='EDIT') ? ('editar') : ('eliminar'))+' un movimiento relacionado a una venta',
            }
        }
        
        if (data.success) {
            this.setState({
                id: data.id,
                caja_id: data.caja ? data.caja.id : null,
                cuenta_id: data.cuenta ? data.cuenta.id : null,
                tipoMovimiento: data.tipoMovimiento,
                fecha: moment(data.fecha),
                monto: data.monto,
                observacion: data.observacion,
                monedaOperacion: data.moneda_operacion ? data.moneda_operacion : null,
                montos_pagados: data.montos_pagados ? data.montos_pagados : [],
            })
        }
    }

    setErrors(errors) {
        this.setState({
            errors: errors,
        });
    }

    onChangeField(field, value) {
        this.setState(prevState => {
            let errors = prevState.errors;
            if (errors) errors[field] = null;
            prevState.errors = errors;
            prevState[field] = value;
            return prevState;
        });
    }

    getError(field) {
        let errors = this.state.errors;
        if (errors) return errors[field];
        else return null;
    }

    onValidation(){
        const { monto, caja_id, cuenta_id } = this.state;
        let error = {};
        let validate = true;

        if (monto<=0){
            error.monto = [{code: "required", detail: "Seleccione un monto"}];
            validate = false;
        }

        if (caja_id==null){
            error.caja_id = [{code: "required", detail: "Seleccione una caja"}];
            validate = false;
        }

        if (cuenta_id==null){
            error.cuenta_id = [{code: "required", detail: "Seleccione una cuenta"}];
            validate = false;
        }

        this.setState({
            errors: error,
        })
        return validate;
    }

    modalVars() {
        const { action } = this.props;
        if (action == "CREATE") {
            return {
                get: false,
                submitType: "POST",
                title: "Nuevo Movimiento",
                buttonTitle: "Nuevo",
                danger: false,
                buttonIcon: "fa fa-plus fa-lg",
                successMessage: "El Movimiento ha sido creado con éxito.",
                saveButton: true,
                saveButtonLabel: "Guardar",
                buttonClass: "",
                disabled: false,
            };
        } else if (action == "EDIT") {
            return {
                get: true,
                submitType: "PUT",
                title: "Editar Movimiento",
                buttonTitle: "Editar",
                danger: false,
                buttonIcon: "fa fa-pencil fa-lg",
                successMessage: "El Movimiento ha sido editado con éxito.",
                saveButton: true,
                saveButtonLabel: "Guardar",
                buttonClass: "",
                disabled: false,
                id: this.props.id,
            };
        } else if (action == "DETAIL") {
            return {
                get: true,
                submitType: null,
                title: "Movimiento",
                buttonTitle: "Ver",
                danger: false,
                buttonIcon: "fa fa-search fa-lg",
                successMessage: "",
                saveButton: false,
                buttonClass: "",
                disabled: true,
                id: this.props.id,
            };
        } else if (action == "DELETE") {
            return {
                get: true,
                submitType: "DELETE",
                title: "Eliminar Movimiento",
                buttonTitle: "Eliminar",
                danger: true,
                buttonIcon: "fa fa-trash fa-lg",
                successMessage: "El Movimiento ha sido eliminado con éxito.",
                saveButton: true,
                saveButtonLabel: "Eliminar",
                buttonClass: "btn-danger",
                disabled: true,
                id: this.props.id,
            };
        }
    }

    onOpen = () => {
        const {} = this.state;
        const { action, caja_id, cuenta_id, tipoDefecto } = this.props;
        apiFunctions.get(api.caja.usuarioCaja, null, null, null, (response) => {
            if(response && response.data && response.data.caja_id){
                this.setState({caja_id: response.data.caja_id});
            }
        });

        if(action=='CREATE'){
            this.setState({
                caja_id: (caja_id) ? (caja_id) : null,
                cuenta_id: (cuenta_id) ? (cuenta_id) : null,
                tipoMovimiento: (tipoDefecto) ? (tipoDefecto) : 0,
            })
        }
    }

    getMonedaSymbol = () => {
        const { monedaOperacion } = this.state;
        if (monedaOperacion){
            return monedaOperacion.simbolo
        } else {
            return "$"
        }
    }

    /**
    * Las monedas involucradas en los montos pagados, sin repetir.
    *
    * (Nota) Se sacan de los montos pagados y no de la api porque el modal solo
    * muestra lo que ya se pago, y toda la info de esas monedas (id, nombre y
    * simbolo) ya viene adentro de cada monto pagado.
    */
    getMonedasDeMontosPagados = () => {
        const { montos_pagados } = this.state;
        let monedas = [];

        montos_pagados.forEach(montoPagado => {
            [montoPagado.moneda_fuente, montoPagado.moneda_objetivo].forEach(moneda => {
                if (moneda && !monedas.some(monedaAgregada => monedaAgregada.id === moneda.id)){
                    monedas.push(moneda)
                }
            })
        })

        return monedas
    }

    /**
    * La moneda nativa son los pesos argentinos.
    *
    * (Nota) Puede ser null, si el movimiento no tiene montos pagados todavia.
    */
    getMonedaNativa = () => {
        const monedaNativa = this.getMonedasDeMontosPagados().find(
            moneda => moneda.id === Monedas.PESOS
        );

        return monedaNativa ? monedaNativa : null
    }

    /**
    * Se asume que hay como maximo dos monedas: la nativa y una extranjera.
    *
    * (Nota) Puede ser null, si todo se pago en pesos una operacion en pesos.
    */
    getMonedaExtranjera = () => {
        const monedaExtranjera = this.getMonedasDeMontosPagados().find(
            moneda => moneda.id !== Monedas.PESOS
        );

        return monedaExtranjera ? monedaExtranjera : null
    }

    /**
    * La moneda en la que estaba expresada la operacion que se pago, es la misma
    * para todos los montos pagados.
    *
    * (Nota) Se cae a la moneda de la operacion por si no hay montos pagados.
    */
    getMonedaObjetivo = () => {
        const { montos_pagados, monedaOperacion } = this.state;

        const montoPagado = montos_pagados.find(montoPagado => montoPagado.moneda_objetivo);

        return montoPagado ? montoPagado.moneda_objetivo : monedaOperacion
    }

    /**
    * Comparaciones de monedas a prueba de nulos.
    *
    * Retornan false si alguna de las dos monedas no existe, asi no hay que
    * repetir el chequeo en cada uno de los lugares donde se comparan.
    */
    esMonedaNativa = (moneda) => {
        const monedaNativa = this.getMonedaNativa()

        return Boolean(moneda && monedaNativa && (moneda.id === monedaNativa.id))
    }

    esMonedaExtranjera = (moneda) => {
        const monedaExtranjera = this.getMonedaExtranjera()

        return Boolean(moneda && monedaExtranjera && (moneda.id === monedaExtranjera.id))
    }

    /**
    * (Nota) La cotizacion de las monedas extranjeras siempre esta en pesos.
    *
    * Se asume que al menos una de las dos monedas es la nativa, mientras que la
    * otra es una moneda extranjera.
    */
    getCotizacionMonedaExtranjera = (montoPagado) => {
        var cotizacionMonedaExtranjera = 0;

        if (this.esMonedaExtranjera(montoPagado.moneda_fuente)){
            cotizacionMonedaExtranjera = montoPagado.fuente_cotizacion_pesos;
        }

        if (this.esMonedaExtranjera(montoPagado.moneda_objetivo)){
            cotizacionMonedaExtranjera = montoPagado.objetivo_cotizacion_pesos;
        }

        return cotizacionMonedaExtranjera
    }

    convertirMontoNativaAExtranjera = (montoNativa, cotizacionExtranjera) => {
        // (Nota) Sin cotizacion no se puede convertir, se devuelve 0 en lugar
        // de dividir por cero.
        if (!cotizacionExtranjera) {
            return 0
        }

        return montoNativa / cotizacionExtranjera
    }

    convertirMontoExtranjeraANativa = (montoExtranjera, cotizacionExtranjera) => {
        return montoExtranjera * cotizacionExtranjera
    }

    /**
    * El monto pagado expresado en la moneda objetivo.
    *
    * Si se pago con la misma moneda objetivo no hay conversion, el monto ya
    * esta en esa moneda.
    */
    getEquivalencia = (montoPagado) => {
        const montoFuente = montoPagado.fuente_monto;
        const cotizacionExtranjera = this.getCotizacionMonedaExtranjera(montoPagado);

        if (this.esMonedaNativa(montoPagado.moneda_fuente) && this.esMonedaExtranjera(montoPagado.moneda_objetivo)){
            return this.convertirMontoNativaAExtranjera(montoFuente, cotizacionExtranjera)
        }

        if (this.esMonedaExtranjera(montoPagado.moneda_fuente) && this.esMonedaNativa(montoPagado.moneda_objetivo)){
            return this.convertirMontoExtranjeraANativa(montoFuente, cotizacionExtranjera)
        }

        return montoFuente
    }

    /**
    * El total esta expresado en la moneda objetivo, por eso se suman las
    * equivalencias y no los montos fuente.
    */
    getTotalMontoPagado = () => {
        const { montos_pagados } = this.state;
        let total = 0;

        montos_pagados.forEach(montoPagado => {
            total += this.getEquivalencia(montoPagado);
        })

        return total
    }

    render() {
        const { 
            caja_id, 
            cuenta_id, 
            tipoMovimiento, 
            fecha, 
            monto, 
            observacion,
            montos_pagados
        } = this.state;

        let vars = this.modalVars();

        // (Nota) Pueden ser null, no hay montos pagados en un movimiento que se
        // esta creando ni en uno que no salio de una operacion en dos monedas.
        const monedaNativa = this.getMonedaNativa()
        const monedaObjetivo = this.getMonedaObjetivo()

        // Si se pago con la misma moneda de la operacion, el monto ya esta en
        // esa moneda y alcanza con mostrar un solo campo.
        // Si se pago con la otra moneda, se muestra el tipo de cambio, el monto
        // en la moneda con la que se pago y su equivalencia en la moneda de la
        // operacion.
        const esMonedaDeLaOperacion = (montoPagado) =>
            montoPagado.moneda_fuente.id === montoPagado.moneda_objetivo.id

        return (
            <ParadigmaModal
                getUrl={(vars.get ? api.caja.movimientosCaja : null)}
                submitUrl={(vars.submitType ? api.caja.movimientosCaja : null)}
                submitType={vars.submitType}
                id={vars.id}

                onGotData={(data) => this.setData(data)}
                onGotErrors={(errors) => this.setErrors(errors)}
                onSubmit={(e) => this.props.onSubmit(e)}
                onClose={() => this.resetForm()}
                onOpen={() => this.onOpen()}
                onPreSubmit={() => this.getData()}
                onValidation={() => this.onValidation()}

                title={vars.title}

                danger={vars.danger}
                className="ui-paradigma-modal ui-paradigma-modal-wide"
                buttonClass={vars.buttonClass}

                successMessage={vars.successMessage}
                missingIdMessage={"Debe seleccionar una fila."}
                saveButtonLabel={vars.saveButtonLabel}
                buttonTitle={vars.buttonTitle}
                buttonIcon={vars.buttonIcon}
                saveButton={vars.saveButton}
                closeButton={true}
            >
                <Fragment>
                    <section className="ui-modal-section">
                        <p className="ui-section-label">Datos del movimiento</p>
                        <div className="ui-form-grid ui-form-grid-3">
                            <ParadigmaLabeledInput
                                md={[12, 12]}
                                classNames={["ui-field-label-col", "ui-field-control-col"]}
                                label={"Fecha"}
                                error={() => this.getError('fecha')}
                                inputComponent={
                                    <ParadigmaDatePicker
                                        disabled={vars.disabled}
                                        value={fecha}
                                        onChange={data => this.onChangeField('fecha', data)}
                                    />
                                }
                            />

                            <ParadigmaLabeledInput
                                md={[12, 12]}
                                classNames={["ui-field-label-col", "ui-field-control-col"]}
                                label={"Caja"}
                                inputComponent={
                                    <ParadigmaAsyncSeeker
                                        clearable={false}
                                        disabled={vars.disabled}
                                        url={api.caja.caja}
                                        parameters={{
                                            sort:['nombre'],
                                            paginationEnabled:false,
                                        }}
                                        value={caja_id}
                                        onChange={(data) => this.onChangeField('caja_id', (data ? data.id : null))}
                                    />
                                }
                                error={() => this.getError('caja_id')}
                            />

                            <ParadigmaLabeledInput
                                disabled={vars.disabled}
                                md={[12, 12]}
                                classNames={["ui-field-label-col", "ui-field-control-col"]}
                                label={"Tipo Mov."}
                                inputComponent={
                                    <ParadigmaAsyncSeeker
                                        disabled={vars.disabled}
                                        url={undefined}
                                        optionDefault={[{nombre: 'Ingreso', id: 0}, {nombre: 'Egreso', id: 1}]}
                                        value={tipoMovimiento}
                                        onChange={data => (data) ? (this.onChangeField('tipoMovimiento', data.id)) : (this.onChangeField('tipoMovimiento', 0))}
                                        clearable={false}
                                    />
                                }
                                error={() => this.getError('tipoMovimiento')}
                            />

                            <div className="ui-span-2">
                                <ParadigmaLabeledInput
                                    md={[12, 12]}
                                    classNames={["ui-field-label-col", "ui-field-control-col"]}
                                    label={"Cuenta"}
                                    inputComponent={
                                        <ParadigmaAsyncSeeker
                                            clearable={false}
                                            disabled={vars.disabled}
                                            url={api.caja.cuentas}
                                            parameters={{
                                                sort:['nombre'],
                                                paginationEnabled:false,
                                            }}
                                            value={cuenta_id}
                                            onChange={(data) => {this.onChangeField('cuenta_id', (data ? data.id : null)); 
                                                this.onChangeField('tipoMovimiento', (data ? data.tipoDefecto : tipoDefecto)); 
                                                this.onChangeField('observacion', ((data && observacion=='') ? data.leyenda : observacion));}}
                                        />
                                    }
                                    error={() => this.getError('cuenta_id')}
                                />
                            </div>

                            <ParadigmaLabeledInput
                                md={[12, 12]}
                                classNames={["ui-field-label-col", "ui-field-control-col"]}
                                label={"Monto"}
                                error={() => this.getError('monto')}
                                inputComponent={
                                    <ParadigmaCurrencyInput
                                        disabled={vars.disabled}
                                        className="form-control monto w-100"
                                        symbol={this.getMonedaSymbol()}
                                        value={formatCurrency(monto)}
                                        onChange={data => this.onChangeField('monto', data)}
                                    />
                                }
                            />

                            <div className="ui-span-3">
                                <ParadigmaLabeledInput
                                    md={[12, 12]}
                                    classNames={["ui-field-label-col", "ui-field-control-col"]}
                                    label={"Observación"}
                                    disabled={vars.disabled}
                                    error={() => this.getError('observacion')}
                                    value={observacion}
                                    onChange={data => this.onChangeField('observacion', data.target.value)}
                                    maxLength={500}
                                />
                            </div>
                        </div>
                    </section>

                    {(montos_pagados.length > 0) &&
                        <section className="ui-modal-section">
                            <p className="ui-section-label">Montos pagados según moneda</p>
                            <div className="ui-money-grid">

                            {/* Cotización de la Moneda Extranjera, ocupa la fila entera */}
                            {montos_pagados.map(monto_pagado => (
                                <Fragment key={monto_pagado.id}>
                                    {!esMonedaDeLaOperacion(monto_pagado) &&
                                        <div className="ui-span-2">
                                            <ParadigmaLabeledInput
                                                md={[12, 12]}
                                                classNames={["ui-field-label-col", "ui-field-control-col"]}
                                                label={"Tipo de Cambio"}
                                                inputComponent={
                                                    <ParadigmaCurrencyInput
                                                        disabled={true}
                                                        className="form-control monto w-100"
                                                        symbol={monedaNativa ? monedaNativa.simbolo : "$"}
                                                        value={formatCurrency(this.getCotizacionMonedaExtranjera(monto_pagado))}
                                                        onChange={() => {}} // Hacer nada
                                                    />
                                                }
                                            />
                                        </div>
                                    }
                                </Fragment>
                            ))}

                            {/* Se paga con la misma moneda de la operacion */}
                            {montos_pagados.map(monto_pagado => (
                                <Fragment key={monto_pagado.id}>
                                    {esMonedaDeLaOperacion(monto_pagado) &&
                                        <Fragment>
                                            <div/>

                                            <div>
                                                <ParadigmaLabeledInput
                                                    md={[12, 12]}
                                                    classNames={["ui-field-label-col", "ui-field-control-col"]}
                                                    label={monto_pagado.moneda_fuente.nombre}
                                                    inputComponent={
                                                        <ParadigmaCurrencyInput
                                                            disabled={true}
                                                            className="form-control monto w-100"
                                                            symbol={monto_pagado.moneda_fuente.simbolo}
                                                            value={formatCurrency(monto_pagado.fuente_monto)}
                                                            onChange={() => {}} // Hacer nada
                                                        />
                                                    }
                                                />
                                            </div>
                                        </Fragment>
                                    }
                                </Fragment>
                            ))}

                            {/* Se paga con una moneda distinta a la de la operacion */}
                            {montos_pagados.map(monto_pagado => (
                                <Fragment key={monto_pagado.id}>
                                    {!esMonedaDeLaOperacion(monto_pagado) &&
                                        <Fragment>
                                            <div>
                                                <ParadigmaLabeledInput
                                                    md={[12, 12]}
                                                    classNames={["ui-field-label-col", "ui-field-control-col"]}
                                                    label={monto_pagado.moneda_fuente.nombre}
                                                    inputComponent={
                                                        <ParadigmaCurrencyInput
                                                            disabled={true}
                                                            className="form-control monto w-100"
                                                            symbol={monto_pagado.moneda_fuente.simbolo}
                                                            value={formatCurrency(monto_pagado.fuente_monto)}
                                                            onChange={() => {}} // Hacer nada
                                                        />
                                                    }
                                                />
                                            </div>
                                            <div>
                                                <ParadigmaLabeledInput
                                                    md={[12, 12]}
                                                    classNames={["ui-field-label-col", "ui-field-control-col"]}
                                                    label={"Equivalencia"}
                                                    inputComponent={
                                                        <ParadigmaCurrencyInput
                                                            disabled={true}
                                                            className="form-control monto w-100"
                                                            symbol={monto_pagado.moneda_objetivo.simbolo}
                                                            value={formatCurrency(this.getEquivalencia(monto_pagado))}
                                                            onChange={() => {}} // Hacer Nada
                                                        />
                                                    }
                                                />
                                            </div>
                                        </Fragment>
                                    }
                                </Fragment>
                            ))}

                            {/* Monto Total */}
                            {(montos_pagados.length > 1) &&
                                <Fragment>
                                    <div/>

                                    <div>
                                        <ParadigmaLabeledInput
                                            md={[12, 12]}
                                            classNames={["ui-field-label-col", "ui-field-control-col"]}
                                            label={"Total"}
                                            inputComponent={
                                                <ParadigmaCurrencyInput
                                                    disabled={true}
                                                    className="form-control monto w-100"
                                                    symbol={monedaObjetivo ? monedaObjetivo.simbolo : this.getMonedaSymbol()}
                                                    value={formatCurrency(this.getTotalMontoPagado())}
                                                    onChange={() => {}} // Hacer nada
                                                />
                                            }
                                        />
                                    </div>
                                </Fragment>
                            }
                            </div>
                        </section>
                    }
                </Fragment>
            </ParadigmaModal>
        );
    }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/views/Caja/MovimientosCaja/Modal.js